import { WatchAccountService } from '../../../services/watch-account.service';
import { AccountService } from '../../../services/account.service';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'modal-funnel-confirm-pause',
  template: require('./modal-funnel-confirm-pause.component.pug'),
})
export class ModalFunnelConfirmPauseComponent implements OnInit {
  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private account_service: AccountService,
    private watch_account: WatchAccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {}

  // -------------------------------------------------------------------
  confirm() {
    console.log('CONFIRMED!');
  }
}
